// src/pages/Connexion.js

import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { signIn } from 'aws-amplify/auth';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Connexion() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);

  // Redirige vers la page d'où venait l'utilisateur, ou vers la recherche par défaut
  const from = location.state?.from?.pathname || "/recherche";
    // On récupère le message de succès s'il existe
  const successMessage = location.state?.message;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      // Appel à la fonction de connexion d'Amplify
      await signIn({ username: email, password });
      
      // Redirige vers la page "from" après une connexion réussie
      navigate(from, { replace: true });

    } catch (err) {
      // Affiche les erreurs de connexion (ex: mot de passe incorrect)
      let friendlyMessage = err.message;
      if (err.name === 'UserNotFoundException' || err.name === 'NotAuthorizedException') {
        friendlyMessage = "L'adresse e-mail ou le mot de passe est incorrect.";
      }
      setError(friendlyMessage);
    }
  };

  return (
    <section className="login-section">
      <div className="login-container">
        <h2>Connexion</h2>
         {/* Affiche le message de succès ici */}
        {successMessage && <p style={{ color: 'green', marginBottom: '15px' }}>{successMessage}</p>}
        <form className="login-form" onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Adresse e-mail"
            aria-label="Adresse e-mail"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div style={{ position: 'relative' }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Mot de passe"
              aria-label="Mot de passe"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: '100%', paddingRight: '40px' }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#6b7280',
                padding: '0',
                marginTop: '0', // Override du style global des boutons
                boxShadow: 'none', // Override du style global
                width: 'auto' // IMPORTANT : Empêche le bouton de prendre 100% de la largeur
              }}
              aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
              title={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          
          {/* Affiche le message d'erreur uniquement s'il y en a un */}
          {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
          
          <button type="submit">Se connecter</button>
        </form>
        <p className="login-footer">
          <Link to="/mot-de-passe-oublie">Mot de passe oublié ?</Link>
        </p>
        <p className="login-footer">
          Pas encore de compte ? <Link to="/identification">Créer un compte</Link>
        </p>
      </div>
    </section>
  );
}

export default Connexion;